import { Grid } from '@mui/material';
import React from 'react';
import { useOnMobile } from '../hooks/breakpoints';

export default function FormItem({
    first = false,
    half = false,
    third = false,
    quarter = false,
    vertical = false,
    sx = undefined,
    children = undefined,
    span = undefined,
    ...rest
}) {
    const isMobile = useOnMobile();
    const s = span || (isMobile ? 12 : half ? 6 : third ? 4 : quarter ? 3 : 12);
    return rest.hidden ? (
        <></>
    ) : (
        <Grid
            className="_formItem"
            flexWrap={'nowrap'}
            size={{
                sm: s,
                xs: quarter ? 6 : 12
            }}
            sx={{ gap: 2, ...sx, display: 'flex', flexDirection: vertical ? 'column' : 'row' }}
            {...rest}
        >
            {children}
        </Grid>
    );
}
